import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';

import LeadForm from 'components/forms/leads/LeadForm';

class LeadNewForm extends React.Component {
  componentDidUpdate = prevProps => {
    const { onSubmitParent, formStatus } = this.props;

    if (onSubmitParent && prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      onSubmitParent(formStatus.response);
    }
  };

  render() {
    const { onSubmit, onSubmitParent, formStatus, pipelineType = 'lead' } = this.props;

    return (
      <LeadForm
        type="new"
        onSubmit={onSubmit}
        onSubmitParent={onSubmitParent}
        formStatus={formStatus}
        pipelineType={pipelineType}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.leadNew,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: args => {
      formStatusDispatchHelper('leadNew', '/api/leads.json', args, 'post', dispatch);
    },
    onFormSuccessfull: () => {
      dispatch(formReset('leadNew'));
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LeadNewForm)
);
